import { API, Endpoints, Project } from '@brg/api';
import { useEffect, useState } from 'react';

interface UseUserCompetitionCardsAndProjectsProps {
  competitionId?: string;
  isPaidApplication: boolean | null | undefined;
}

interface UseUserCompetitionCardsAndProjectsResult {
  userHasAvailablePaidCard: boolean;
  isLoading: boolean;
  participationProjects: Project[];
  pendingProjects: Project[];
  rejectedProjects: Project[];
}

interface CompetitionCardsAndProjectsResponse {
  participationCardsCnt?: number;
  participationProjectsCnt?: number;
  pendingProjectsCnt?: number;
  rejectedProjectsCnt?: number;
  participationProjects?: Project[];
  pendingProjects?: Project[];
  rejectedProjects?: Project[];
}

export const useUserCompetitionCardsAndProjects = ({
  competitionId,
  isPaidApplication,
}: UseUserCompetitionCardsAndProjectsProps): UseUserCompetitionCardsAndProjectsResult => {
  const [userHasAvailablePaidCard, setUserHasAvailablePaidCard] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [participationProjects, setParticipationProjects] = useState<Project[]>([]);
  const [pendingProjects, setPendingProjects] = useState<Project[]>([]);
  const [rejectedProjects, setRejectedProjects] = useState<Project[]>([]);

  useEffect(() => {
    if (!isPaidApplication || !competitionId) {
      setUserHasAvailablePaidCard(false);
      setParticipationProjects([]);
      setPendingProjects([]);
      setRejectedProjects([]);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    API.request()
      .endpoint(Endpoints.competitions)
      .url('/api/Competition/GetUserCompetitionCardsAndProjects')
      .addQuery('competitionId', competitionId)
      .get()
      .send()
      .then(response => response.json())
      .then((competitionData: CompetitionCardsAndProjectsResponse) => {
        const participationCardsCnt = Number(competitionData?.participationCardsCnt) || 0;
        const participationProjectsCnt = Number(competitionData?.participationProjectsCnt) || 0;
        const pendingProjectsCnt = Number(competitionData?.pendingProjectsCnt) || 0;
        const rejectedProjectsCnt = Number(competitionData?.rejectedProjectsCnt) || 0;
        const allProjectsCnt = pendingProjectsCnt + participationProjectsCnt + rejectedProjectsCnt;

        setUserHasAvailablePaidCard(participationCardsCnt > allProjectsCnt);
        setParticipationProjects(
          Array.isArray(competitionData?.participationProjects) ? competitionData.participationProjects : [],
        );
        setPendingProjects(
          Array.isArray(competitionData?.pendingProjects) ? competitionData.pendingProjects : [],
        );
        setRejectedProjects(
          Array.isArray(competitionData?.rejectedProjects) ? competitionData.rejectedProjects : [],
        );
      })
      .catch(() => {
        setUserHasAvailablePaidCard(false);
        setParticipationProjects([]);
        setPendingProjects([]);
        setRejectedProjects([]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [competitionId, isPaidApplication]);

  return { userHasAvailablePaidCard, isLoading, participationProjects, pendingProjects, rejectedProjects };
};
import { API, Endpoints, Project } from '@brg/api';
import { useEffect, useState } from 'react';

interface UseUserCompetitionCardsAndProjectsProps {
  competitionId?: string;
  isPaidApplication: boolean | null | undefined;
}

interface UseUserCompetitionCardsAndProjectsResult {
  userHasAvailablePaidCard: boolean;
  isLoading: boolean;
  participationProjects: Project[];
  pendingProjects: Project[];
  rejectedProjects: Project[];
}

interface CompetitionCardsAndProjectsResponse {
  participationCardsCnt?: number;
  participationProjectsCnt?: number;
  pendingProjectsCnt?: number;
  rejectedProjectsCnt?: number;
  participationProjects?: Project[];
  pendingProjects?: Project[];
  rejectedProjects?: Project[];
}

export const useUserCompetitionCardsAndProjects = ({
  competitionId,
  isPaidApplication,
}: UseUserCompetitionCardsAndProjectsProps): UseUserCompetitionCardsAndProjectsResult => {
  const [userHasAvailablePaidCard, setUserHasAvailablePaidCard] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [participationProjects, setParticipationProjects] = useState<Project[]>([]);
  const [pendingProjects, setPendingProjects] = useState<Project[]>([]);
  const [rejectedProjects, setRejectedProjects] = useState<Project[]>([]);

  useEffect(() => {
    if (!isPaidApplication || !competitionId) {
      setUserHasAvailablePaidCard(false);
      setParticipationProjects([]);
      setPendingProjects([]);
      setRejectedProjects([]);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    API.request()
      .endpoint(Endpoints.competitions)
      .url('/api/Competition/GetUserCompetitionCardsAndProjects')
      .addQuery('competitionId', competitionId)
      .get()
      .send()
      .then(response => response.json())
      .then((competitionData: CompetitionCardsAndProjectsResponse) => {
        const participationCardsCnt = Number(competitionData?.participationCardsCnt) || 0;
        const participationProjectsCnt = Number(competitionData?.participationProjectsCnt) || 0;
        const pendingProjectsCnt = Number(competitionData?.pendingProjectsCnt) || 0;
        const rejectedProjectsCnt = Number(competitionData?.rejectedProjectsCnt) || 0;
        const allProjectsCnt = pendingProjectsCnt + participationProjectsCnt + rejectedProjectsCnt;

        setUserHasAvailablePaidCard(participationCardsCnt > allProjectsCnt);
        setParticipationProjects(
          Array.isArray(competitionData?.participationProjects) ? competitionData.participationProjects : [],
        );
        setPendingProjects(
          Array.isArray(competitionData?.pendingProjects) ? competitionData.pendingProjects : [],
        );
        setRejectedProjects(
          Array.isArray(competitionData?.rejectedProjects) ? competitionData.rejectedProjects : [],
        );
      })
      .catch(() => {
        setUserHasAvailablePaidCard(false);
        setParticipationProjects([]);
        setPendingProjects([]);
        setRejectedProjects([]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [competitionId, isPaidApplication]);

  return { userHasAvailablePaidCard, isLoading, participationProjects, pendingProjects, rejectedProjects };
};
